var map = {
	"./404.svg": 84258,
	"./add-comment.svg": 97423,
	"./add-note.svg": 51484,
	"./add.svg": 32040,
	"./adv_caret.svg": 2895,
	"./adv_filter.svg": 35258,
	"./allocation-plan.svg": 51513,
	"./allocation.svg": 54789,
	"./approval.svg": 1852,
	"./approve.svg": 5023,
	"./assembly.svg": 37276,
	"./audit.svg": 89580,
	"./availabilities.svg": 14313,
	"./back.svg": 97809,
	"./barcode.svg": 17199,
	"./bins.svg": 41621,
	"./book.svg": 19667,
	"./bottles.svg": 85083,
	"./brands.svg": 66034,
	"./bug.svg": 23878,
	"./calendar.svg": 73535,
	"./carts.svg": 40804,
	"./categories.svg": 67842,
	"./certificate-alt-2.svg": 4986,
	"./change.svg": 70513,
	"./chart.svg": 61770,
	"./clear.svg": 68385,
	"./clipboard.svg": 60778,
	"./cloud-upload.svg": 42167,
	"./comments.svg": 47700,
	"./company.svg": 76369,
	"./component.svg": 91374,
	"./containers.svg": 4652,
	"./daily-orders.svg": 61498,
	"./daily.svg": 86435,
	"./dashboard.svg": 96693,
	"./data.svg": 4565,
	"./datetime.svg": 2285,
	"./decision.svg": 63139,
	"./delete.svg": 22125,
	"./delivery-time.svg": 79258,
	"./disapprove.svg": 47903,
	"./documentation.svg": 60786,
	"./documents.svg": 97344,
	"./dollar-plus.svg": 13211,
	"./dollar.svg": 2832,
	"./download.svg": 73294,
	"./drag.svg": 89047,
	"./edit.svg": 73044,
	"./education.svg": 47606,
	"./email.svg": 25487,
	"./eraser.svg": 31019,
	"./example.svg": 38375,
	"./excel.svg": 48969,
	"./exit-fullscreen.svg": 61078,
	"./eye-open.svg": 35644,
	"./eye.svg": 96359,
	"./file-spreadsheet.svg": 78815,
	"./files-stack.svg": 47945,
	"./filter.svg": 15125,
	"./finish-order.svg": 69531,
	"./finish_testing.svg": 51625,
	"./fire.svg": 70461,
	"./flask.svg": 28132,
	"./flavors.svg": 54280,
	"./flow-actions.svg": 22359,
	"./flows.svg": 18254,
	"./forecast.svg": 7317,
	"./form.svg": 9927,
	"./fullscreen.svg": 554,
	"./google-map.svg": 68138,
	"./graduate.svg": 36512,
	"./grocery.svg": 33045,
	"./guide.svg": 31900,
	"./hand.svg": 6567,
	"./hat-alt.svg": 24107,
	"./hat.svg": 49444,
	"./history.svg": 15954,
	"./hplc.svg": 29085,
	"./icon.svg": 77907,
	"./imports.svg": 29799,
	"./info.svg": 87635,
	"./input-hplc.svg": 46748,
	"./interface.svg": 66747,
	"./international.svg": 36133,
	"./inventory.svg": 66214,
	"./invoice.svg": 72196,
	"./items.svg": 63900,
	"./language.svg": 74364,
	"./link-alt.svg": 24858,
	"./link.svg": 53312,
	"./list.svg": 85870,
	"./location-arrow.svg": 95698,
	"./locations.svg": 64075,
	"./lock.svg": 71414,
	"./machines.svg": 28837,
	"./manage-recipes.svg": 8569,
	"./map.svg": 84949,
	"./mathematical-alt-1.svg": 6461,
	"./maximize.svg": 56321,
	"./merged-order.svg": 37935,
	"./message.svg": 49534,
	"./messages.svg": 91123,
	"./minus.svg": 83714,
	"./money.svg": 72524,
	"./nested.svg": 34910,
	"./notes.svg": 62473,
	"./numbered.svg": 24866,
	"./operations.svg": 23635,
	"./orders-create.svg": 62342,
	"./orders.svg": 96749,
	"./parameters.svg": 91250,
	"./password.svg": 30030,
	"./pause.svg": 29054,
	"./pdf.svg": 62005,
	"./people.svg": 20193,
	"./peoples.svg": 32934,
	"./phases.svg": 67535,
	"./pixels.svg": 22302,
	"./play.svg": 44347,
	"./positions.svg": 83683,
	"./price-tier.svg": 76061,
	"./print.svg": 14210,
	"./product-import-settings.svg": 40321,
	"./production-orders.svg": 63129,
	"./productions.svg": 80700,
	"./products.svg": 62051,
	"./project.svg": 19911,
	"./projects.svg": 31525,
	"./provinces.svg": 50461,
	"./qq.svg": 48473,
	"./qr-code.svg": 52596,
	"./random.svg": 18517,
	"./rd.svg": 83900,
	"./receiving.svg": 96464,
	"./recipe-ingredients.svg": 38111,
	"./recipe_proposals.svg": 25134,
	"./recipes.svg": 6267,
	"./recoveries.svg": 41503,
	"./redo.svg": 63919,
	"./reels.svg": 34781,
	"./refresh.svg": 11916,
	"./rickshaw.svg": 89773,
	"./roles.svg": 41349,
	"./sample.svg": 27363,
	"./samples.svg": 84983,
	"./save.svg": 25402,
	"./save2.svg": 34031,
	"./schedule.svg": 7653,
	"./search-document.svg": 93217,
	"./search-recipes.svg": 64583,
	"./search.svg": 52679,
	"./settings-alt.svg": 92488,
	"./settings.svg": 36607,
	"./size.svg": 87608,
	"./skill.svg": 43801,
	"./speed-meter.svg": 42337,
	"./stamp.svg": 39313,
	"./star.svg": 63839,
	"./start_testing.svg": 12664,
	"./status.svg": 83989,
	"./stock-report.svg": 68982,
	"./stop.svg": 59885,
	"./suppliers.svg": 77817,
	"./sync.svg": 60098,
	"./tab.svg": 95434,
	"./table.svg": 14750,
	"./tag.svg": 4220,
	"./tags.svg": 87785,
	"./theme.svg": 83560,
	"./thin-right.svg": 11771,
	"./training-classes.svg": 1299,
	"./training-logs.svg": 24968,
	"./training.svg": 85141,
	"./transfer-report.svg": 13344,
	"./tree-table.svg": 42602,
	"./tree.svg": 42753,
	"./truck-loaded.svg": 88162,
	"./truck.svg": 52229,
	"./ui-calculator.svg": 60427,
	"./undo.svg": 30703,
	"./university.svg": 92386,
	"./upload.svg": 24039,
	"./user.svg": 21138,
	"./view.svg": 38809,
	"./waiting.svg": 76966,
	"./warehouses.svg": 17905,
	"./warning-alt.svg": 88307,
	"./wechat.svg": 73943,
	"./zip.svg": 30554
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87886;